import { ContentSetup } from '../model/contents.model';

export const PROJECTS: ContentSetup[] = [
    {
        name: 'Baxter:Prismaflex',
        thumb: 'prisma.png',
        poster: 'baxter_prisma.jpg',
        demo: 'vid|Baxter Prismaflex-high.mp4',
        embed: 'vid|https://player.vimeo.com/video/511260965',
        copy: 'Medical sales tool for Baxters Prismaflex.',
        platform: 'iPad',
        url: '',
        tech: [5,7,8,10,12,17,18,25,28,30],
        active: true
    },
    {
        name: "Baxter:Patient Journey",
        thumb: "journey.png",
        poster: "baxter_journey.JPG",
        demo: "vid|Baxter Patient Journey-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511260901",
        copy: "Interactive experience and sales tool following four patient journeys.",
        platform: "iPad, mural",
        url: "",
        tech: [5,7,8,10,12,17,18,25,28],
        active: true
      },
      {
        name: "Inhance Digital Marketing Agency",
        thumb: "inhance.png",
        poster: "inhance.png",
        demo: "vid|Inhance Digital Marketing Agency-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511260825",
        copy: "Offical website for Inhance Digital Marketing Agency",
        platform: "responsive",
        url: "https://www.inhance.com/",
        tech: [0,2,5,6,10,14,17,18,19,24,25,27,28,30],
        active: true
      },
      {
        name: "Cummins:2.0 Engine Interactive",
        thumb: "2.0.png",
        poster: "2.0.JPG",
        demo: "vid|Cummins Engine Interactive-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511260679",
        copy: "International, interactive marketing campaign for Cummins Engines On-Highway engines.",
        platform: "mural, surfacePro",
        url: "https://www.cummins.com/engines",
        tech: [0,2,5,6,10,14,17,18,19,24,25,28,30],
        active: true
      },
      {
        name: "Cummins:ConExpo",
        thumb: "con_expo.png",
        poster: "cummins17FEB02.png",
        demo: "vid|Cummins ConExpo-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511260939",
        copy: "Interactive experience and product information tool for Cummins' Off-Highway Engine Components.",
        platform: "mural, surfacePro",
        url: "https://www.cummins.com/generators-power-systems",
        tech: [0,2,5,6,10,14,17,18,19,24,25,28,30],
        active: true
      },
      {
        name: "Cummins:IAA",
        thumb: "iaa.png",
        poster: "iaa.jpg",
        demo: "vid|Cummins IAA-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511261003",
        copy: "Interactive experience and product information tool for Cummins' On-Highway Engine Components.",
        platform: "mural, surfacePro",
        url: "https://www.cummins.com/components",
        tech: [0,2,5,6,10,14,17,18,19,24,25,28,30],
        active: true
      },
      {
        name: "Illumina:Merlion",
        thumb: "illumina.png",
        poster: "illumina.jpg",
        demo: "vid|Illumina MiniSeq-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511261054",
        copy: "Interactive product journey through Illumina's Miniseq",
        platform: "responsive",
        url: "",
        tech: [5,6,7,10,12,17,18,19,24],
        active: true
      },
      {
        name: "Aviall:Interactive Display",
        thumb: "aviall.png",
        poster: "aviall.jpg",
        demo: "vid|Boeing Aviall Interactive-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511261145",
        copy: "Services interactive for Aviall, aircraft parts distributor and subsidiary of The Boeing Company.",
        platform: "mural",
        url: "",
        tech: [0,2,5,6,10,14,17,18,19,24,25,28,29,30],
        active: true
      },
      {
        name: "Valent:Biosciences",
        thumb: "valent.png",
        poster: "valent.JPG",
        demo: "vid|Valent BioSciences-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511261104",
        copy: "Informational sales tool for mosquito and Zika awareness.",
        platform: "surfacePro",
        url: "",
        tech: [0,2,5,6,10,14,17,18,19,24,25,28,30],
        active: true
      },
      {
        name: "AT&T Hackathon:Cheatah",
        thumb: "cheatah.png",
        poster: "cheatah.jpg",
        demo: "img|cheatah.jpg",
        embed: "img|cheatah.jpg",
        copy: "Study buddy locator through collegiate interests.",
        platform: "responsive",
        url: "cheatah.tdogg.io",
        tech: [5,10,17,18,19,24,25,27,31],
        active: false
      },
      {
        name: "DevLeague:Fastenate",
        thumb: "fastenate.png",
        poster: "fastenate.jpg",
        demo: "img|fastenate.jpg",
        embed: "img|fastenate.jpg",
        copy: "Responsive, live json reader",
        platform: "responsive",
        url: "fastenate.tdogg.io",
        tech: [5,6,10,17,18,19,24,25,27,31],
        active: false
      },
      {
        name: "Devleague:Flappy App",
        thumb: "flappy.png",
        poster: "flappy.jpg",
        demo: "img|flappy.jpg",
        embed: "img|flappy.jpg",
        copy: "Responsive app",
        platform: "responsive",
        url: "flappy.tdogg.io",
        tech: [6,17,18],
        active: false
      },
      {
        name: "Devleague:GeezMail",
        thumb: "geezmail.png",
        poster: "geezmail.jpg",
        demo: "img|geezmail.jpg",
        embed: "img|geezmail.jpg",
        copy: "Email simulator challenge for DevLeague admission.",
        platform: "desktop",
        url: "geezmail.tdogg.io",
        tech: [17,18],
        active: false
      },
      {
        name: "Global Game Jam:JigDraw",
        thumb: "jigdraw.png",
        poster: "jigdraw.jpg",
        demo: "img|jigdraw.jpg",
        embed: "img|jigdraw.jpg",
        copy: "Winning game for Global Game Jam, Honolulu",
        platform: "desktop",
        url: "jigdraw.tdogg.io",
        tech: [17,18,19,27],
        active: false
      },
      {
        name: "TEDx Honolulu:Paradigm Shift:Scheduler",
        thumb: "tedxfront.png",
        poster: "tedxfront.jpg",
        demo: "img|tedxfront.jpg",
        embed: "img|tedxfront.jpg",
        copy: "Android app for TEDx Honolulu's Paradigm Shift event program.",
        platform: "responsive",
        url: "",
        tech: [0,1,2,3,5,9,14,17,18,19,24,25,27,31],
        active: false
      },
      {
        name: "TEDx Honolulu:Paradigm Shift:CMS",
        thumb: "tedx.png",
        poster: "tedx.jpg",
        demo: "img|tedx.jpg",
        embed: "img|tedx.jpg",
        copy: "Content Management system for TEDx Honolulu's event program app.",
        platform: "responsive",
        url: "",
        tech: [0,1,2,3,5,13,14,17,18,19,24,25,27,31],
        active: false
      },
      {
        name: "Personal:TechWomen",
        thumb: "techwomen.png",
        poster: "itwomen.jpg",
        demo: "img|itwomen.jpg",
        embed: "img|itwomen.jpg",
        copy: "Web resource for the empowerment of Women in Tech",
        platform: "responsive",
        url: "techwomen.tdogg.io",
        tech: [0,1,2,3,5,14,17,18,19,24,25,27,31],
        active: false
      },
      {
        name: "DevLeague:NewsFeed",
        thumb: "newsfeed.png",
        poster: "newsfeed.jpg",
        demo: "img|newsfeed.jpg",
        embed: "img|newsfeed.jpg",
        copy: "CMS driven site for our most famous human beings.",
        platform: "responsive",
        url: "newsfeed.tdogg.io",
        tech: [0,1,2,3,5,9,14,17,18,19,24,25,27,31],
        active: false
      },
      {
        name: "AT&T Hackathon LA:IBM Watson",
        thumb: "todo.png",
        poster: "watson.jpg",
        demo: "img|watson.jpg",
        embed: "img|watson.jpg",
        copy: "1st place winner of IBM's Best Use of Watson at AT&T Hackathon LA. An end-to-end web solution that analyzes personality/tone of famous speakers using IBM Watson's Text/Tone Analysis and Personality Insights.",
        platform: "desktop",
        url: "",
        tech: [0,10,17,18,19,27,32,33,34],
        active: false
      },
      {
        name: "DevLeague:Starfox Travel Agency",
        thumb: "starfox.png",
        poster: "starfox.jpg",
        demo: "img|starfox.jpg",
        embed: "img|starfox.jpg",
        copy: "",
        platform: "responsive",
        url: "",
        tech: [6,17,18,31],
        active: false
      },
      {
        name: "IBM:Ripple",
        thumb: "starfox.png",
        poster: "starfox.jpg",
        demo: "vid|IBM Ripple Effect-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511322612",
        copy: "",
        platform: "responsive",
        url: "https://www.ibm.com/events/activations-ripple-effect/",
        tech: [6,17,18,31],
        active: true
      },
      {
        name: "IBM:Quantum",
        thumb: "starfox.png",
        poster: "starfox.jpg",
        demo: "vid|IBM Quantum-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511260636",
        copy: "",
        platform: "responsive",
        url: "https://www.ibm.com/events/activations-quantum",
        tech: [6,17,18,31],
        active: true
      },
      {
        name: "IBM: Think City",
        thumb: "starfox.png",
        poster: "starfox.jpg",
        demo: "vid|IBM Think City-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511260584",
        copy: "",
        platform: "responsive",
        url: "https://www.ibm.com/events/activations-think-city/",
        tech: [6,17,18,31],
        active: true
      },   
      {
        name: "Adobe: Platinum Club",
        thumb: "starfox.png",
        poster: "starfox.jpg",
        demo: "vid|Adobe Platinum Club.mp4",
        embed: "vid|https://player.vimeo.com/video/511425393",
        copy: "",
        platform: "responsive",
        url: "",
        tech: [6,17,18,31],
        active: true
      },
      {
        name: "Nissan: NEXT Lineup",
        thumb: "starfox.png",
        poster: "starfox.jpg",
        demo: "vid|Nissan NEXT Lineup-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511425580",
        copy: "",
        platform: "responsive",
        url: "https://www.nissanusa.com/live/zreveal",
        tech: [6,17,18,31],
        active: true
      },  
      {
        name: "FM Global: Hacker Resilience",
        thumb: "starfox.png",
        poster: "starfox.jpg",
        demo: "vid|FM Global Hacker Resilience-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511263904",
        copy: "",
        platform: "responsive",
        url: "",
        tech: [6,17,18,31],
        active: true
      },  
      {
        name: "Andersen:VR Showroom",
        thumb: "starfox.png",
        poster: "starfox.jpg",
        demo: "vid|Andersen VR-high.mp4",
        embed: "vid|https://player.vimeo.com/video/511363802",
        copy: "",
        platform: "responsive",
        url: "",
        tech: [6,17,18,31],
        active: true
      }
]